module.exports = __webpack_public_path__ + "static/media/icon.82ea2a84.png";